import { get } from "lodash";
import { Code } from "../types/code";
import { CodeableConcept } from "../types/codeableConcept";

export const createCodeableConcept = (
  system,
  code,
  display,
): CodeableConcept => ({
  coding: [
    {
      system,
      code,
      display,
    },
  ],
  text: display,
});

export const createCodeFromCcodeableConcept = (
  codeableConcept: CodeableConcept,
): Code => {
  if (codeableConcept) {
    return {
      code: codeableConcept.coding[0]?.code,
      display: codeableConcept?.text || codeableConcept.coding[0]?.display,
    };
  }
};

export const isCodeableConceptEqualToValue = (
  option: any,
  value: any,
  isMultiple?: boolean,
) => {
  let isEqual = false;

  if (option && value) {
    isEqual = option.code === value[0]?.code;
  }
  return isEqual;
};

export const isReferenceEqualToOption = (option: any, value: any) => {
  let isEqual = false;

  if (option && value) {
    isEqual = option.code === value?.identifier;
  }
  return isEqual;
};

export const isCodeableConcept = (concept) => {
  const code = get(concept, "coding[0].code");
  return code !== undefined && code !== null;
};

export const isPremiumOrganization = (adminSettings) => {
  if (!adminSettings) return false;
  if (get(adminSettings, "tier") === "PREMIUM") {
    return true;
  }
  return false;
};

const UNLIMITED_SCRIBE_MINUTE_TIERS = new Set([
  "PREMIUM",
  "ENTERPRISE",
  "AI_SCRIBE",
]);

/**
 * AI Scribe minutes are unlimited for PREMIUM / ENTERPRISE / AI_SCRIBE tiers,
 * or when the AI_SCRIBE addon is present on another plan.
 */
export const isAiScribeMinutesUnlimited = (
  adminSettings?: { tier?: string } | null,
  entitlements?: { tier?: string; addOns?: string[] } | null,
): boolean => {
  const tier = (entitlements?.tier || adminSettings?.tier || "").toUpperCase();
  if (UNLIMITED_SCRIBE_MINUTE_TIERS.has(tier)) {
    return true;
  }
  return (entitlements?.addOns || []).some(
    (addon) => addon?.toUpperCase() === "AI_SCRIBE",
  );
};

export const getOrganizationTier = (adminSettings) =>
  get(adminSettings, "tier");

export const blobToBase64 = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error("Failed to read blob"));
    reader.readAsDataURL(blob);
  });
